import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=97dbc0e0&scoped=true"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dbc0e0",
  null
  
)

export default component.exports